<template>
	<el-main class="portal-ai">
		<Banner />
    	<LmIntro />
		<LmApplicationEngine />
		<LmLoopClose/>
	</el-main>
</template>

<script>
	import Banner from './AiLMBanner'
  	import LmIntro from './LmIntro'
	import LmApplicationEngine from './LmApplicationEngine'
	import LmLoopClose from './LmLoopClose'
	export default {
		name: 'PortalLM',
		components: {
			Banner,
			LmApplicationEngine,
			LmIntro,
			LmLoopClose
		},
		data() {
			return {}
		}
	}
</script>

<style>
	.rect-bg {
		position: absolute;
		left: 0;
		float: left;
		width: calc(100vw - 17px);
		min-width: 1200px;
		height: 2549px;
		-webkit-clip-path: polygon(45% 0, 100% 0, 36% 100%, 0 100%);
		clip-path: polygon(45% 0, 100% 0, 36% 100%, 0 100%);
		background: rgba(255,255,255,.3);
	}
  .portal-ai {
    position: relative; background-color: rgba(234,242,249,.22);
    overflow-y: hidden;
  }
</style>
<style></style>


// WEBPACK FOOTER //
// src/components/PortalLM.vue